import UserHackathonsApp from '@/apps/devpost_homepage/user_hackathons_app';
import ThemeLeaderboardApp from '@/apps/devpost_homepage/theme_leaderboard_app';
import UserHackathonRecommendationApp from '@/apps/devpost_homepage/user_hackathon_recommendation_app';
import FeaturedHackathons from '@/apps/devpost_homepage/featured_hackathons_app';
import NearbyHackathons from '@/apps/devpost_homepage/nearby_hackathons_app';
import { initializeAdTracking } from 'components/homepage_ad_tracking';

UserHackathonsApp();
ThemeLeaderboardApp();
UserHackathonRecommendationApp();
FeaturedHackathons();
NearbyHackathons();

// Initialize ad tracking after DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAdTracking);
} else {
  initializeAdTracking();
}
